import React, { FC } from 'react';
import { AddUnitsFormProps } from "./AddUnitInterfaces";
import { AddUnitsForm } from "./AddUnitsForm";

export const DefaultAddUnitsForm: FC<AddUnitsFormProps> = props => {
    return (<AddUnitsForm {...props}/>);
}
